import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import Text from "../Text";

/**
 * TableData - Tabela responsiva reutilizável.
 *
 * Props:
 * - tHead: Array de strings para cabeçalhos.
 * - data: Array de objetos com os dados da tabela.
 * - tBodyKeys: Chaves que mapeiam os dados do corpo.
 * - tableId: ID único para evitar conflito de keys.
 * - tHeadStyle: Estilo customizado do cabeçalho.
 * - tHeadWhiteText: Exibe cabeçalho com texto branco (boolean).
 */
export default function TableData({
  tHead,
  data,
  tBodyKeys,
  tableId,
  tHeadStyle,
  tHeadWhiteText,
}) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = useCallback(() => {
    setScreenWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [handleWindowSizeChange]);

  const isMobile = screenWidth <= 768;

  return (
    <div className={isMobile ? "overflow-auto" : ""}>
      <Table bordered striped hover responsive data-cy-test="table-data">
        <thead>
          <tr>
            {tHead.map((th, index) => (
              <th
                key={`thead-${tableId}-${index}`}
                style={tHeadStyle}
              >
                {tHeadWhiteText ? (
                  th
                ) : (
                  <Text color="primary">{th}</Text>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={tHead.length}>
                <Text align={"center"} >Nenhum dado disponível</Text>
              </td>
            </tr>
          ) : (
            data.map((item, rowIndex) => (
              <tr key={`row-${tableId}-${rowIndex}`} data-cy-test={`table-data-row=${rowIndex}`}>
                {tBodyKeys.map((key, colIndex) => (
                  <td
                    key={`cell-${tableId}-${rowIndex}-${colIndex}`}
                    data-cy-test={`table-data-cell=${rowIndex}-${colIndex}`}
                  >
                    <Text color="primary">
                    {item[key] != null ? item[key] : "-"}
                    </Text>
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

TableData.propTypes = {
  tHead: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  tBodyKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  tableId: PropTypes.string,
  tHeadStyle: PropTypes.object,
  tHeadWhiteText: PropTypes.bool,
};

TableData.defaultProps = {
  tableId: "default",
  tHeadStyle: {},
  tHeadWhiteText: false,
};



// WEBPACK FOOTER //
// ./src/_components/TableData/index.jsx